// extracted by mini-css-extract-plugin
export default {"sam_base":"NiRZs52HINrBf0sLsnOB"};